import { ScanLine, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, SCAN_URL } from "../lib/site";

export const PricingBrief = () => (
  <section className="py-16 sm:py-24">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <div className="hazard-frame overflow-hidden rounded-3xl border border-brandamber/30 bg-panel p-7 text-center sm:p-12">
          <p className="font-mono text-[11px] tracking-[0.28em] text-brandamber">PLAIN PRICING, BRIEFLY</p>
          <p className="mt-4 font-display text-4xl sm:text-6xl text-white leading-none">
            $25<span className="text-2xl sm:text-3xl text-slate-400">/mo</span>
            <span className="text-2xl sm:text-3xl text-slate-500"> or $200</span>
            <span className="text-2xl sm:text-3xl text-slate-400">/yr</span>
          </p>
          <p className="mx-auto mt-4 max-w-2xl font-mono text-xs sm:text-sm leading-relaxed text-slate-400">
            ONE WEBSITE · <span className="font-bold text-white">$299</span> ONE-TIME SETUP COVERS ONE DOMAIN · CODE FIXES UP TO 1,000 PAGES · ALT TEXT FOR
            1,000 IMAGES · ALL 84 FEATURES INCLUDED
          </p>
          <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row">
            <a
              data-testid="pricing-scan-cta-button"
              href={SCAN_URL}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-brandamber px-7 py-3.5 font-bold text-ink transition-all hover:scale-[1.03] active:scale-95"
            >
              <ScanLine className="h-5 w-5" /> Start With a FREE Scan
            </a>
            <a
              data-testid="pricing-call-cta-button"
              href={PHONE_TEL}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-3.5 font-semibold text-white transition-all hover:border-white hover:bg-white/5"
            >
              <Phone className="h-5 w-5" /> Ask a Question — {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
